import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "selected-items" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "dropdown-icon" }
const _hoisted_8 = {
  key: 0,
  class: "dropdown-options"
}
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "selected-items" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "dropdown-icon" }
const _hoisted_16 = {
  key: 0,
  class: "dropdown-options"
}
const _hoisted_17 = ["id", "value"]
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-actions" }
const _hoisted_21 = {
  type: "submit",
  class: "btn btn-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t('components.notificationsHistory.modal.deleteByCriteria')), 1),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmDeleteAll && _ctx.confirmDeleteAll(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t('components.notificationsHistory.modal.deleteByNotificationTypes')), 1),
              _createElementVNode("div", {
                class: "multiselect-dropdown",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleNotificationTypesDropdown && _ctx.toggleNotificationTypesDropdown(...args)), ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.selectedNotificationTypes.length === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.t('components.notificationsHistory.modal.selectNotificationTypes')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedNotificationTypesLabels.join(', ')), 1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.isNotificationTypesDropdownOpen ? 'icon-up' : 'icon-down')
                  }, null, 2)
                ])
              ]),
              (_ctx.isNotificationTypesDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationTypeOptions, (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.value,
                        class: "dropdown-option"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'notification-type-' + option.value,
                          value: option.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedNotificationTypes) = $event)),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, _hoisted_9), [
                          [_vModelCheckbox, _ctx.selectedNotificationTypes]
                        ]),
                        _createElementVNode("label", {
                          for: 'notification-type-' + option.value
                        }, _toDisplayString(option.label), 9, _hoisted_10)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t('components.notificationsHistory.modal.deleteByVehiclesTypes')), 1),
              _createElementVNode("div", {
                class: "multiselect-dropdown",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVehiclesDropdown && _ctx.toggleVehiclesDropdown(...args)), ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.selectedVehicles.length === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.t('components.notificationsHistory.modal.selectVehicles')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.selectedVehiclesLabels.join(', ')), 1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.isVehiclesDropdownOpen ? 'icon-up' : 'icon-down')
                  }, null, 2)
                ])
              ]),
              (_ctx.isVehiclesDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleOptions, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.value + '-' + index,
                        class: "dropdown-option"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: 'vehicle-' + option.value,
                          value: option.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedVehicles) = $event)),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, _hoisted_17), [
                          [_vModelCheckbox, _ctx.selectedVehicles]
                        ]),
                        _createElementVNode("label", {
                          for: 'vehicle-' + option.value
                        }, _toDisplayString(option.label), 9, _hoisted_18)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", null, _toDisplayString(_ctx.t('components.notificationsHistory.modal.deleteOlderThan')), 1),
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.deleteCriteria.olderThanDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deleteCriteria.olderThanDate) = $event)),
                range: false,
                onEmitDate: _ctx.updateOlderThanDate
              }, null, 8, ["modelValue", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _toDisplayString(_ctx.t('components.vehicles.modals.exit')), 1),
              _createElementVNode("button", _hoisted_21, _toDisplayString(_ctx.t('components.notificationsHistory.dataGrids.delete')), 1)
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}